/* Localization Modal — Reliance
   Gère ouverture/fermeture, search filter, focus management.
   Markup : voir snippets/localization-modal.liquid + localization-pill.liquid
*/
(function () {
  const modal = document.querySelector('[data-localization-modal]');
  if (!modal) return;

  // Sort la modal du wrapper sticky du header pour éviter les bugs de
  // positionnement/overlay quand elle est ouverte depuis le footer.
  if (document.body && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  const triggers = document.querySelectorAll('[data-localization-trigger]');
  const closers = modal.querySelectorAll('[data-localization-close]');
  const searchInput = modal.querySelector('[data-localization-search]');
  const list = modal.querySelector('[data-localization-list]');
  let lastFocused = null;

  function openModal() {
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      const firstFocusable = modal.querySelector(
        'button:not([data-localization-close]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusable && typeof firstFocusable.focus === 'function') {
        firstFocusable.focus();
      }
    }, 60);
  }

  function closeModal() {
    if (!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    if (searchInput) {
      searchInput.value = '';
      if (list) {
        list.querySelectorAll('.localization-modal__item').forEach((item) => {
          item.style.display = '';
        });
      }
    }

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  triggers.forEach((t) => t.addEventListener('click', openModal));
  closers.forEach((c) => c.addEventListener('click', closeModal));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      e.preventDefault();
      closeModal();
    }
  });

  if (searchInput && list) {
    const items = list.querySelectorAll('.localization-modal__item');
    searchInput.addEventListener('input', (e) => {
      const q = e.target.value.toLowerCase().trim();
      items.forEach((item) => {
        const name = item.getAttribute('data-country-name') || '';
        item.style.display = !q || name.includes(q) ? '' : 'none';
      });
    });
  }
})();

